import {
  Interface,
  useDeleteInterface as useDeleteInterfaceMutation,
  useFavoriteAssets,
} from "@zapier/client";
import { AssetTypes, useNotification } from "@zapier/utils";
import { type DeleteInterfaceInput } from "@zapier/bff";
import { useTranslations } from "@zapier/i18n";

interface Input {
  interfaceObject: Interface | undefined;
  deleteZapsOption?:
    | DeleteInterfaceInput["related_zaps_delete_option"]
    | undefined;
  folderId?: string; // used for cache invalidation in mutations
}

export const useDeleteInterface = ({
  interfaceObject,
  deleteZapsOption,
  folderId,
}: Input) => {
  const { mutate, isPending } = useDeleteInterfaceMutation({ folderId });
  const { createNotification } = useNotification();
  const t = useTranslations("interface-delete-modal");

  const { removeFromFavorites } = useFavoriteAssets();

  const deleteInterface = () => {
    if (!interfaceObject) {
      return;
    }

    mutate(
      { id: interfaceObject.id, related_zaps_delete_option: deleteZapsOption },
      {
        onSuccess: () => {
          createNotification({
            message: t("notifications.delete-success", {
              interfaceName: interfaceObject.name,
            }),
            type: "success",
          });

          removeFromFavorites(interfaceObject.id, AssetTypes.Interface);
        },
        onError: () => {
          createNotification({
            message: t("notifications.delete-error", {
              interfaceName: interfaceObject.name,
            }),
            type: "error",
          });
        },
      },
    );
  };

  return { deleteInterface, isPending };
};
